// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"CampaignResume_blockClick_3KQsG"};